export const authRoutes = {
  LOGIN: '/auth/login',
  LOGOUT: '/auth/logout',
  TOKEN: '/auth/access-token',
  ME: '/auth/profile',
} as const

// app owned page (not an auth0 SDK route)
export const authErrorURL = '/auth/error'
